export default class PossibleStatusTransition {
    static fromData(data) {
        if (!data) {
            return;
        }

        let statusTransition = new PossibleStatusTransition();
        statusTransition.name = data.name;
        statusTransition.targetStatus = data.target_status;

        Object.seal(statusTransition);
        return statusTransition;
    }

    isInFuture() {
        return false;
    }
}
